// Cookie Consent Component
export function initCookieConsent() {

  const CONSENT_COOKIE = 'siteConsent';
  const DEFAULT_CONSENT = { essential: true, analytics: true, marketing: false, timestamp: Date.now() };

  // Check if user already has consent - if yes, don't even create the banner
  const existing = getConsentFromCookie();
  if (existing) {
    applyConsent(existing);
    return; // Exit early, no banner needed
  }

  // No consent found - create and show banner
  createBanner();
  
  function getConsentFromCookie() {
    try {
      const raw = document.cookie.split('; ').find(r => r.startsWith(CONSENT_COOKIE + '='));
      if (!raw) return null;
      const value = decodeURIComponent(raw.split('=')[1]);
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  function setConsent(consent, days = 180) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(JSON.stringify(consent))}; path=/; expires=${expires}; SameSite=Lax`;
  }

  function createBanner() {
    // Lock body scroll
    // document.body.style.overflow = 'hidden';

    // Create overlay backdrop
    // const overlay = document.createElement('div');
    // overlay.id = 'cookieConsentOverlay';
    // overlay.className = 'cookie-consent-overlay';
    // overlay.style.display = 'block';
    // document.body.appendChild(overlay);

    // Create banner
    const el = document.createElement('div');
    el.id = 'cookieConsent';
    el.className = 'cookie-consent';
    el.style.display = 'block';
    el.innerHTML = `
      <div class="cookie-inner">
        <div class="cookie-text">
          <strong>Cookies & Tracking</strong>
          <p>
            We use essential cookies and analytics to improve the site. Marketing cookies (e.g., Facebook Pixel)
            are enabled only if you choose "I Agree". You can change your choice anytime.
          </p>
          <a href="/cookies" class="cookie-link">Cookies Policy</a>
        </div>
        <div class="cookie-actions">
          <button type="button" class="btn btn-outline" data-action="settings">Manage</button>
          <button type="button" class="btn btn-primary" data-action="agree">I Agree</button>
        </div>
      </div>
      <div class="cookie-settings" style="display: none;">
        <div class="cookie-settings-inner">
          <label><input type="checkbox" disabled checked> Essential</label>
          <label><input type="checkbox" data-cat="analytics" checked> Analytics</label>
          <label><input type="checkbox" data-cat="marketing"> Marketing</label>
        </div>
        <div class="cookie-settings-actions">
          <button type="button" class="btn btn-outline" data-action="save">Save</button>
        </div>
      </div>
    `;
    
    document.body.appendChild(el);

    const settingsPanel = el.querySelector('.cookie-settings');
    const analyticsCheckbox = el.querySelector('input[data-cat="analytics"]');
    const marketingCheckbox = el.querySelector('input[data-cat="marketing"]');
    const btnAgree = el.querySelector('[data-action="agree"]');
    const btnSettings = el.querySelector('[data-action="settings"]');
    const btnSave = el.querySelector('[data-action="save"]');

    // Apply default consent (analytics on, marketing off) immediately
    applyConsent(DEFAULT_CONSENT);

    // Actions
    btnAgree?.addEventListener('click', () => {
      const c = { essential: true, analytics: true, marketing: true, timestamp: Date.now() };
      setConsent(c);
      applyConsent(c);
      // document.body.style.overflow = '';
      // overlay.remove();
      el.remove();
    });

    btnSettings?.addEventListener('click', () => {
      const isHidden = settingsPanel.style.display === 'none';
      settingsPanel.style.display = isHidden ? 'block' : 'none';
    });

    btnSave?.addEventListener('click', () => {
      const c = {
        essential: true,
        analytics: !!analyticsCheckbox.checked,
        marketing: !!marketingCheckbox.checked,
        timestamp: Date.now()
      };
      setConsent(c);
      applyConsent(c);
      document.body.style.overflow = '';
      // overlay.remove();
      el.remove();
    });
  }

  function loadGoogleAnalytics() {
    // Wait for footer script to load if needed
    if (typeof window.loadGA !== 'function') {
      // console.warn('[Cookie Consent] window.loadGA not available yet, retrying...');
      // setTimeout(loadGoogleAnalytics, 100);
      return;
    }
    // window.loadGA();
  }

  function loadFacebookPixel() {
    // Wait for footer script to load if needed
    if (typeof window.loadFB !== 'function') {
      // console.warn('[Cookie Consent] window.loadFB not available yet, retrying...');
      // setTimeout(loadFacebookPixel, 100);
      return;
    }
    // window.loadFB();
  }

  function applyConsent(consent) {
    // Load analytics immediately if enabled
    if (consent.analytics) loadGoogleAnalytics();
    // Load marketing only after explicit agree/save with marketing true
    if (consent.marketing) loadFacebookPixel();
  }
}
